import { DataSetField, IDataSetField } from './DataSetField';
import { IConfigurationSection } from '@/models/configuration/Section';

export interface IDataSetSection {
    position: number;
    fields: IDataSetField[];
    identifier: string;
}

export class DataSetSection {
    public position: number;
    public fields: DataSetField[];
    public identifier: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDataSetSection);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationSection);
    constructor(obj?: any) {
        this.position = obj && obj.position || 0;
        this.identifier = obj && obj.identifier || '';
        this.fields = [];
        if (obj && obj.fields !== undefined) {
            obj.fields.forEach((field: any) => {
                this.fields.push(new DataSetField(field));
            });
        }
    }
}
